import { NoticeDto } from "@/data/dto/notice/notice-dto";
import { NoticeInfoEntity } from "@/domain/entity/notice/notice-info-entity";
import { formatLocalToHhMm, formatLocalToYyyyMmDd, serverDateToLocalDate } from "@/utils/date-util";
import { assertNoticeDto } from "@/utils/validation";

export class NoticeInfoMapper {
  static toEntity(notice: NoticeDto, uuid?: string): NoticeInfoEntity {
    // AST 기반 타입 검증
    console.log("[NoticeInfoMapper] :: toEntity :: 입력 데이터:", JSON.stringify(notice, null, 2));
    assertNoticeDto(notice);

    const newTitleInfo = {
      title: notice.title,
      isImportant: Boolean(notice.isPriority),
    };

    let formatedStartTime: string = "";
    let formatedEndTime: string = "";
    let formatedLastModifiedAtDate: string = "";
    let formatedLastModifiedAtTime: string = "";

    if (notice.startViewDate != null) {
      const startTime = new Date(notice.startViewDate);
      formatedStartTime = formatLocalToYyyyMmDd(startTime);
    }

    if (notice.endViewDate != null) {
      const endTime = new Date(notice.endViewDate);
      formatedEndTime = formatLocalToYyyyMmDd(endTime);
    }

    // 서버에서 오는 시간은 utc 기준이므로 변환 필요
    const updatedAtLocal = serverDateToLocalDate(notice.updatedAt);
    if (updatedAtLocal) {
      formatedLastModifiedAtDate = formatLocalToYyyyMmDd(updatedAtLocal);
      formatedLastModifiedAtTime = formatLocalToHhMm(updatedAtLocal);
    }

    const newPublishPeriod = {
      start: formatedStartTime,
      end: formatedEndTime,
    };

    const newLastModifiedAt = {
      date: formatedLastModifiedAtDate,
      time: formatedLastModifiedAtTime,
    };

    // isActive 변환: number, string, boolean, null, undefined를 boolean으로 변환
    let isActiveValue: boolean = true; // 기본값은 true
    if (notice.isActive !== undefined && notice.isActive !== null) {
      if (typeof notice.isActive === "boolean") {
        isActiveValue = notice.isActive;
      } else if (typeof notice.isActive === "string") {
        isActiveValue = notice.isActive === "1";
      } else if (typeof notice.isActive === "number") {
        isActiveValue = notice.isActive === 1;
      }
    }

    const entity = {
      uuid: uuid || notice.uuid || "",
      titleInfo: newTitleInfo,
      content: notice.body || "",
      author: notice.writerName,
      buildNumber: notice.appVersion,
      publishPeriod: newPublishPeriod,
      lastModifiedAt: newLastModifiedAt,
      isActive: isActiveValue,
    };

    return entity;
  }

  static toEntityList(dtos: NoticeDto[]): NoticeInfoEntity[] {
    console.log(
      "[NoticeInfoMapper] :: toEntityList :: 입력 데이터:",
      JSON.stringify(dtos, null, 2)
    );
    return dtos.map((notice) => NoticeInfoMapper.toEntity(notice, notice.uuid));
  }
}
